var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.05 6.45914L23.61 7.44862C24.13 7.64852 24.13 8.37814 23.61 8.57803L21.05 9.56752L20.06 12.1262C19.86 12.6459 19.13 12.6459 18.93 12.1262L17.94 9.56752L15.38 8.57803C14.86 8.37814 14.86 7.64852 15.38 7.44862L17.94 6.45914L18.93 3.90047C19.13 3.38074 19.86 3.38074 20.06 3.90047L21.05 6.45914Z",
    fill: "url(#paint0_linear_1168_11236)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36 1.97147L16.07 2.63113C16.42 2.76106 16.42 3.25081 16.07 3.39073L14.36 4.05039L13.7 5.7595C13.57 6.10932 13.08 6.10932 12.94 5.7595L12.28 4.05039L10.57 3.39073C10.22 3.2608 10.22 2.77106 10.57 2.63113L12.28 1.97147L12.94 0.262363C13.07 -0.0874544 13.56 -0.0874544 13.7 0.262363L14.36 1.97147Z",
    fill: "url(#paint1_linear_1168_11236)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24C8.23 24 7.56 23.5003 7.34 22.7606L5.94 18.0631L1.24 16.6638C0.5 16.4439 0 15.7743 0 15.0047C0 14.2351 0.5 13.5654 1.24 13.3455L5.94 11.9463L7.34 7.24872C7.56 6.50911 8.23 6.00937 9 6.00937C9.77 6.00937 10.44 6.50911 10.66 7.24872L12.06 11.9463L16.76 13.3455C17.5 13.5654 18 14.2351 18 15.0047C18 15.7743 17.5 16.4439 16.76 16.6638L12.06 18.0631L10.66 22.7606C10.44 23.5003 9.77 24 9 24ZM2.66 15.0047L6.64 16.1941C7.2 16.364 7.64 16.7938 7.81 17.3535L9 21.3414L10.19 17.3635C10.36 16.8037 10.8 16.364 11.36 16.1941L15.34 15.0047L11.36 13.8153C10.8 13.6454 10.36 13.2156 10.19 12.6559L9 8.66798L7.81 12.6459C7.64 13.2056 7.2 13.6454 6.64 13.8153L2.66 15.0047Z",
    fill: "url(#paint2_linear_1168_11236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_11236",
    x1: -1.82397e-7,
    y1: 17.0127,
    x2: 35,
    y2: 5.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246118,
    stopColor: "#28B8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B8AF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1168_11236",
    x1: -1.82397e-7,
    y1: 17.0127,
    x2: 35,
    y2: 5.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246118,
    stopColor: "#28B8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B8AF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1168_11236",
    x1: -1.82397e-7,
    y1: 17.0127,
    x2: 35,
    y2: 5.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246118,
    stopColor: "#28B8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B8AF",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.90390384f7d342b05bf036b5cebca9bc.svg";
export { ForwardRef as ReactComponent };